module.exports = __webpack_public_path__ + "static/media/student-end-season-score.68d02ef9.png";